import React, { useState, useEffect, useRef, forwardRef } from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";
class ThuChiNgoaiLePrint extends React.Component {
  renderTableData() {
    if (typeof this.props.dataPrint.List != "undefined") {
      return this.props.dataPrint.List.map((item, i) => {
        return (
          <tr>
            <td style={{ border: "1px solid #EEE", textAlign: "center" }}>
              {i + 1}
            </td>
            <td style={{ border: "1px solid #EEE" }}>{item.MaTaiSan}</td>
            <td style={{ border: "1px solid #EEE" }}>{item.TenTaiSan}</td>
            <td style={{ border: "1px solid #EEE" }}>{item.TenKho}</td>
            <td style={{ border: "1px solid #EEE" }}>{item.MaHopDong}</td>
            <td style={{ border: "1px solid #EEE" }}>{item.TenKhachHang}</td>
            <td style={{ border: "1px solid #EEE" }}>{item.SoTienVay}</td>
            <td style={{ border: "1px solid #EEE" }}>{item.TenTrangThai}</td>
          </tr>
        );
      });
    }
  }

  render() {
    return (
      <>
        <div id={this.props.dataPrint.TypeName}>
          <table style={{ width: "90%", margin: "0 auto" }}>
            <tr>
              <td
                style={{
                  textAlign: "center",
                  width: "100%",
                  fontWeight: "bold",
                  fontSize: "18px",
                  color: "#000000",
                }}
              >
                <br />
                DANH SÁCH TÀI SẢN
              </td>
            </tr>
            <tr>
              <td style={{ width: "100%" }}>
                <table
                  style={{
                    border: "1px solid #EEE",
                    width: "100%",
                    color: "#000000",
                  }}
                >
                  <tr>
                    <th
                      style={{ border: "1px solid #EEE", textAlign: "center" }}
                    >
                      <div>STT</div>
                      <span>[ {this.props.dataPrint.TongBanGhi} ]</span>
                    </th>
                    <th style={{ border: "1px solid #EEE" }}>Mã tài sản</th>
                    <th style={{ border: "1px solid #EEE" }}>Tên tài sản</th>
                    <th style={{ border: "1px solid #EEE" }}>Kho</th>
                    <th style={{ border: "1px solid #EEE" }}>Mã hợp đồng</th>
                    <th style={{ border: "1px solid #EEE" }}>Tên khách hàng</th>
                    <th style={{ border: "1px solid #EEE" }}>Số tiền</th>
                    <th style={{ border: "1px solid #EEE" }}>
                      Trạng thái tài sản
                    </th>
                  </tr>

                  {this.renderTableData()}
                </table>
              </td>
            </tr>
          </table>
        </div>
      </>
    );
  }
}
export default ThuChiNgoaiLePrint;
